import dayjs from 'dayjs';

import { DateTimeFormats } from '@ge/models/constants';

export const calculateDuration = (startTime, endTime, calendarDate, startDate, endDate) => {
  if (!startTime || !endTime) return `0 hr 0 m 0 s`;
  if (!startDate || !endDate) return `0 hr 0 m 0 s`;
  const startday = dayjs(startDate || calendarDate).format(DateTimeFormats.ENDPOINT_PARAM);
  const endday = dayjs(endDate || calendarDate).format(DateTimeFormats.ENDPOINT_PARAM);
  let st = dayjs(`${startday} ${startTime}`);
  let et = dayjs(`${endday} ${endTime}`);
  if (startTime instanceof Date || typeof startTime === 'number') {
    st = dayjs(`${startday} ${dayjs(startTime).format('HH:mm:ss')}`);
  }
  if (endTime instanceof Date || typeof endTime === 'number') {
    et = dayjs(`${endday} ${dayjs(endTime).format('HH:mm:ss')}`);
  }
  const diffInMs = et.diff(st);
  const diffDuration = dayjs.duration(diffInMs);
  const days = Math.floor(diffDuration.asDays());
  const hours = diffDuration.hours();
  const minutes = diffDuration.minutes();
  const seconds = diffDuration.seconds();
  let dateString = '';
  if (days > 0) {
    dateString += `${days} ${days === 1 ? ' day ' : ' days '}`;
  }

  return `${dateString}${hours} hr ${minutes} m ${seconds} s`;
};
